import type { QuickStepsStore } from "./schema/QuickStepsConfig";
import { createStore } from "owa-satcheljs";
const defaultExport: () => QuickStepsStore = createStore<QuickStepsStore>("quickStepsStore", {
    quickStepsStoreMap: new Map(),
    loadingStatesMap: new Map(),
});
export default defaultExport;
